/* eslint-disable react/no-array-index-key */
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import { observer } from "mobx-react";
import 'swiper/css';
import 'swiper/css/pagination';
import Image from 'next/image';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import studioStore from '@/stores/studioStore';

const HeroSection = observer(({
  slides,
}) => {
  const { isMobile } = useWindowDimensions();

  return (
    <div className="hero-section max-w-[1920px] mx-auto">
      <Swiper
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop
        pagination={{
          clickable: true,
          renderBullet: (index, className) => {
            // Customize each bullet with inline style
            return `<span className="${className}" style="background-color: ${studioStore.settings.colors.primary_color}; width: 12px; height: 12px; margin: 0 6px;"></span>`;
          },
        }}
        modules={[Pagination, Autoplay]}
      >
        {Array.isArray(slides) && slides.map((slide, index) => {
          // Select the appropriate image object
          const imageObj = isMobile && slide.image_mobile?.url ? slide.image_mobile : slide.image;

          if (!imageObj?.url || !imageObj?.width || !imageObj?.height) {
            console.warn(`Missing required image properties for slide ${index + 1}`);
            return null;
          }

          const { url, alt, width, height } = imageObj;

          return (
            <SwiperSlide key={index}>
              <a href={slide.url} rel="noopener noreferrer">
                <Image
                  src={url}
                  alt={alt || `Slide ${index + 1}`}
                  width={width}
                  height={height}
                  priority
                  sizes={`(max-width: 768px) 100vw, (max-width: 1200px) 50vw, ${width}px`}
                  quality={80}
                />
              </a>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
});

export default HeroSection;